<section
  class="ba-form-group ba-layout-tile">
  <h2 class="ba-heading ueberschrift-groesse">
    @if (zaehler) {
      {{zaehler < 10 ? 0 : ''}}{{zaehler}}
    }
    {{ anzeigetext }}
  </h2>
  <ng-content select="[buttonContent]"/>
</section>
